module.exports = __webpack_public_path__ + "img/Kettenfahrzeug.4ce232fc.svg";